import React, { useState, useEffect } from 'react';
import { Link, useLocation } from 'react-router-dom';
import './Header.css';

const Header = () => {
  const [isScrolled, setIsScrolled] = useState(false);
  const [isMobileMenuOpen, setIsMobileMenuOpen] = useState(false);
  const [isDropdownOpen, setIsDropdownOpen] = useState(false);
  const location = useLocation();

  const navItems = [
    { path: '/', label: '首页' },
    { path: '/products', label: '产品' },
    { path: '/industry', label: '行业应用' },
    { path: '/news', label: '信息与资源', hasDropdown: true },
    { path: '/contact', label: '联系与购买' },
  ];

  const dropdownItems = [
    { path: '/news', label: '信息发布' },
    { path: '/resources', label: '资源下载' },
  ];

  useEffect(() => {
    const handleScroll = () => {
      setIsScrolled(window.scrollY > 20);
    };
    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);

  useEffect(() => {
    setIsMobileMenuOpen(false);
  }, [location]);

  const isNewsOrResources = location.pathname === '/news' || location.pathname.startsWith('/news/') || location.pathname === '/resources';

  return (
    <header className={`header ${isScrolled ? 'header-scrolled' : ''}`}>
      <div className="container header-container">
        <Link to="/" className="logo">
          <img src="/logo.png" alt="微趣AI" className="logo-image" />
        </Link>

        <nav className={`nav ${isMobileMenuOpen ? 'nav-open' : ''}`}>
          {navItems.map((item) => (
            item.hasDropdown ? (
              <div
                key={item.path}
                className="nav-dropdown-wrapper"
                onMouseEnter={() => setIsDropdownOpen(true)}
                onMouseLeave={() => setIsDropdownOpen(false)}
              >
                <Link
                  to={item.path}
                  className={`nav-link ${isNewsOrResources ? 'active' : ''}`}
                >
                  {item.label}
                </Link>
                {isDropdownOpen && (
                  <div className="nav-dropdown">
                    {dropdownItems.map((dropdownItem) => (
                      <Link
                        key={dropdownItem.path}
                        to={dropdownItem.path}
                        className={`dropdown-item ${location.pathname === dropdownItem.path || (dropdownItem.path === '/news' && location.pathname.startsWith('/news/')) ? 'active' : ''}`}
                      >
                        {dropdownItem.label}
                      </Link>
                    ))}
                  </div>
                )}
              </div>
            ) : (
              <Link
                key={item.path}
                to={item.path}
                className={`nav-link ${location.pathname === item.path ? 'active' : ''}`}
              >
                {item.label}
              </Link>
            )
          ))}
        </nav>

        <button
          className={`mobile-menu-btn ${isMobileMenuOpen ? 'open' : ''}`}
          onClick={() => setIsMobileMenuOpen(!isMobileMenuOpen)}
          aria-label="菜单"
        >
          <span></span>
          <span></span>
          <span></span>
        </button>
      </div>
    </header>
  );
};

export default Header;